import React from 'react';
import DataGrid2 from '../..';
import { IDataGridColumn } from '../../entities';
import { IControlProperties } from '../../../../../../entities';

export const ViewFile: React.FC<{
	dataGrid: DataGrid2;
	value: string;
	column: IDataGridColumn<IControlProperties>;
}> = props => {
	if (!props.column.enlargeOnClick) {
		return <></>;
	}

	const handleView = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.stopPropagation();

		props.dataGrid.__form.__interactionHelper({
			id: 'DATAGRID_IMAGE_MODAL',
			type: 'modal',
			contentComponentType: 'DataGridImageModal',
			contentComponentProps: { value: props.value },
			modalProps: {
				props: {
					renderHeader: () => null,
					disableScroll: true,
					maskClosable: true,
					footer: null
				}
			}
		});
	};

	return (
		<i
			className="dx-icon-eyeopen"
			onClick={handleView}
		/>
	);
};
